import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  DateInterval,
  Page,
  Prescription,
  PrescriptionForm
} from '../models';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionService {

  url = environment.dns + 'prescription';

  constructor(private http: HttpClient) { }

  add(prescription: PrescriptionForm): Observable<Prescription> {
    return this.http.post<Prescription>(this.url, prescription);
  }

  update(prescription: PrescriptionForm): Observable<Prescription> {
    return this.http.put<Prescription>(this.url, prescription);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.url}/${id}`);
  }

  getOne(id: number): Observable<Prescription> {
    return this.http.get<Prescription>(`${this.url}/${id}`);
  }

  getPaginate(page: number, size: number, search: string): Observable<Page<Prescription>> {
    return this.http.get<Page<Prescription>>(`${this.url}/paginate?page=${page}&size=${size}&search=${search || ''}`);
  }

  getListByResponsableRegional(responsableRegionalId: number): Observable<Prescription[]> {
    return this.http.get<Prescription[]>(`${this.url}/responsable-regional/${responsableRegionalId}`);
  }

  getListByPeriod(dateInterval: DateInterval): Observable<Prescription[]> {
    return this.http.post<Prescription[]>(`${this.url}/period`, dateInterval);
  }

  addCps(id: number, filePayload: string, extension?: string): Observable<void> {
    return this.http.post<void>(`${this.url}/${id}/cps`, {
      filePayload,
      extension: extension || ''
    });
  }

  getCps(id: number): Observable<Prescription> {
    return this.http.get<Prescription>(`${this.url}/${id}/cps`);
  }

  getCpsFileUrl(id: number): string {
    return `${this.url}/${id}/cps/file`;
  }

  deleteCps(id: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.url}/${id}/cps`);
  }
}
